export enum EnumPeriodoLiquidacion {
  Diario = 1,
  Mensual = 2,
  Trimestral = 3,
  Anual = 4,
  Horario = 5,
  Indefinido = 6
}
